import React from 'react'
import './galery-section.scss'
import CardGallery from '../../molecules/card-gallery/card-gallery'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Button from '../../../shared/components/atoms/button/button'
import gallery from '../../../constants/gallery'
import { navigate } from 'gatsby-link'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

function NextArrow(props) {
  const { onClick } = props
  return (
    <div
      className={'f-gallery-section__slide__arrow arrow-next'}
      onClick={()=>{
        onClick()
         pushEventDataLayer(
           'Interacciones - Galería',
           'Cur-v',
           'Click',
           'Derecha'
         )
        }
      }
    />
  )
}

function PrevArrow(props) {
  const { onClick } = props
  return (
    <div
      className="f-gallery-section__slide__arrow arrow-prev"
      onClick={() => {
        onClick()
        pushEventDataLayer(
          'Interacciones - Galería',
          'Cur-v',
          'Click',
          'Izquierda'
        )
      }}
    />
  )
}

const GalerySection = () => {
  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '0',
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          variableWidth: false,
          centerPadding: '30px',
        },
      },
    ],
  }

  return (
    <section className="f-gallery-section">
      <div id="galeria" className="f-gallery-section__ancla" />
      <h2 className="f-gallery-section__title">
        La menstruación que te inspira
      </h2>
      {['es-AR', 'es-PY', 'es-UY'].includes(process.env.LOCALE) ? (
        <p className="f-gallery-section__description">
          Acá vas a encontrar como la menstruación inspiró a
          diferentes artistas.
        </p>
      ) : (
        <p className="f-gallery-section__description">
          En esta galería encontrarás cómo la menstruación ha inspirado a
          diferentes artistas.
        </p>
      )}

      <div>
        <Slider {...settings} className="f-gallery-section__slide">
          {gallery.map((item, i) => {
            if (i < 5) {
              return <CardGallery info={item} key={'gal' + i} slide={true} />
            }
          })}
        </Slider>
      </div>

      <div className="f-gallery-section__btn">
        <Button
          title="Ver toda la galería"
          className="new-dark-pink"
          onClick={() => {
            navigate('/galeria')
            pushEventDataLayer(
              'Interacciones - Galería',
              'Cur-v',
              'Click',
              'Ver toda la galería'
            )
          }}
        />
      </div>
    </section>
  )
}

export default GalerySection
